import React from 'react';
import {List, Datagrid, TextField, ShowButton, EditButton, DeleteButton} from 'react-admin';

class CashbackConditionItemsList extends React.Component {
    render() {
        return (
            <List {...this.props}>
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="cashbackId" label="Cashback Block" />
                    <TextField source="position" />
                    <TextField source="type" />
                    <TextField source="text" />
                    <TextField source="url" />
                    <ShowButton />
                    <EditButton />
                    <DeleteButton />
                </Datagrid>
            </List>
        );
    }
}

export default CashbackConditionItemsList;
